import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { racingLicenseTypeService } from "../../_services/racingLicenseType.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
}

export const RacingLicenseTypeAutoComplete = (params: IStandardExtAutocomplete) => {

    function fetchItems() {
        return racingLicenseTypeService
            .dropdown();
    }

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={fetchItems}
            label={"Racing Licence Type Select"} />
    );
}